module.exports = __webpack_public_path__ + "img/icon-3.d81f6883.png";